export const ASSIGN_MATERIALS_KEYS = {
  RECORDS: "assign-materials",
  MATERIALS: "assign-materials-materials",
  BY_ID: "by-id",
};
